import type { ComponentProps } from 'react';
import type { Button } from '@sweetgreen/garnish';
import { theme } from '@sweetgreen/garnish';

import type { SweetpassUpgradePageTag } from './SweetpassUpgradeScreen.loaded';

const SWEETPASS_UPGRADE_PAGE_PALETTES: SweetpassUpgradeScreenPalettes = {
  'join-sweetpass': {
    backgroundColor: theme.colors.APP_BACKGROUND,
    header: {
      backgroundColor: theme.colors.GREEN_2,
      titleColor: theme.colors.GREEN_6,
      bodyColor: theme.colors.GREEN_6,
      ctaPalette: 'limeOutline',
    },
    benefitList: {
      backgroundColor: theme.colors.APP_BACKGROUND,
      benefit: {
        titleColor: theme.colors.GREEN_2,
        bodyColor: theme.colors.GREEN_2,
        opacity: 1,
      },
    },
    ctaPalette: 'limeOutline',
  },
  'upgrade-to-sweetpass-plus': {
    backgroundColor: theme.colors.APP_BACKGROUND,
    header: {
      backgroundColor: theme.colors.GREEN_6,
      titleColor: theme.colors.GREEN_2,
      bodyColor: theme.colors.GREEN_2,
      ctaPalette: 'limeOnGreen',
    },
    benefitList: {
      backgroundColor: theme.colors.APP_BACKGROUND,
      benefit: {
        titleColor: theme.colors.GREEN_2,
        bodyColor: theme.colors.GREEN_2,
        opacity: 1,
      },
    },
    ctaPalette: 'limeOnGreen',
  },
};

export const getSweetpassUpgradeScreenPaletteForTag = (
  tag?: SweetpassUpgradePageTag,
) => (tag ? SWEETPASS_UPGRADE_PAGE_PALETTES[tag] : undefined);

// ––– TYPES –––––––––––––––––––––––––––––––––––––––––––––

type SweetpassUpgradeScreenPalettes = {
  readonly [Key in SweetpassUpgradePageTag]: SweetpassUpgradeScreenPalette;
};

export type SweetpassUpgradeScreenPalette = {
  readonly backgroundColor: string;
  readonly header: {
    readonly backgroundColor: string;
    readonly titleColor: string;
    readonly bodyColor: string;
    readonly ctaPalette: ButtonPalette;
  };
  readonly benefitList: {
    readonly backgroundColor: string;
    readonly benefit: {
      readonly titleColor: string;
      readonly bodyColor: string;
      readonly opacity: number;
    };
  };
  readonly ctaPalette: ButtonPalette;
};

type ButtonPalette = NonNullable<ComponentProps<typeof Button>['palette']>;
